// extracted by mini-css-extract-plugin
module.exports = {"manage-alternatives-container":"alternatives_manage-alternatives-container__3MbkP"};